<div class="contents">
  <div class="position-relative">
    <div [ngClass]="showWelcome ? '' : 'hidden-welcome'" id="popup-welcome" class="welcome-box">
      <h2 class="h-welcome">Welcome to the Hush City map!</h2>
      <ul class="list-welcome">
        <li>Here you can explore the quiet areas collected by people in your city and worldwide by using the Hush City app!</li>
        <li>The colored markers on the map represent the quiet areas. </li>
        <li>You can click on them to read the user feedback, have a look at the pictures, and listen to the sounds! You can also
          review the quiet areas through the list view mode, if you prefer,
          <span (click)="clickHere()">by clicking here</span>.</li>
        <li>Or filter the quiet areas and visualize them according to their noise levels, the descriptors used by the users to
          tag them, their perceived quietness, the overall visual quality and their accessibility.</li>
        <li>The legend will explain you how to read the colors and the meaning of the numbers placed on the markers.</li>
        <li>We hope you will enjoy your digital journey through the Hush City map. Please, let us know how it goes. Happy (quiet)
          surfing!
        </li>
        <li>And… if you like, you can always join the Hush City community and help us in making our world a quieter place to
          live. Just click here to download the free Hush City app.</li>
      </ul>
      <div class="list-store clearfix">
        <div class="play-store">
          <a href="https://play.google.com/store/apps/details?id=com.hushcity.app&hl=en" target="_blank">
            <img src="assets/images/play-store.png" alt="Download from Google Play Store">
          </a>
        </div>
        <div class="app-store">
          <a href="https://itunes.apple.com/us/app/hush-city/id1174145857?mt=8" target="_blank">
            <img src="assets/images/app-store.png" alt="Download from Apple App Store">
          </a>
        </div>
      </div>
      <div class="pb-welcome"><button class="btn-welcome" (click)="hiddenWelcome()">{{ 'OK' | translate }}</button></div>
    </div>
    <div id="map-box" class="map-box">
      <app-map [data]="areas" [lang]="lang"></app-map>
    </div>
  </div>
</div>